/* eslint-disable @nx/enforce-module-boundaries */
import {
  List,
  ListItem,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  useDisclosure,
} from '@chakra-ui/react';
import {
  ArticleIconColored,
  CalendarNewIcon,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  DiskNewIcon,
  JobsIconColored,
  MyNetworkNewIcon,
  PageIcon,
  HomeIcon,
  ProfileIcon,
  PageIconColored,
  MoreIcon,
  SettingsCardIcon,
  LinkIcons,
  ShareLink,
  Clone,
  Delete,
  TermsIcon,
  HelpSupportIcon,
  BusinessIcon,
  TermsIconColored,
  HelpSupportIconColored,
  BusinessIconColored,
  NotificationIconColored,
  MessageColoredIcon,
} from '@mybridge/icons';
import { MyEventsIcon, MyEventsIconColored } from '@mybridge/icons/MyEvents';
import { SettingsIcon, SettingsIconColored, TeamsIcon, TeamsIconColored } from '@mybridge/icons/user-menu';
import { Button, Card, Link, Badge, Circle } from '@mybridge/ui';
import { Heading } from '@mybridge/ui/heading';
import { Box, HStack, Stack } from '@mybridge/ui/layout';
import { Text } from '@mybridge/ui/text';
import { useMemo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from '../../../components/header/status-dropdown/statusProfile.module.scss';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';
import { getAllConnectionsData, getPendingInvitations } from 'v4/store/actions/connection.actions';
import { useRouter } from 'next/router';
import { useTranslator } from '../../../../mybridgeui/src/custom-hooks/useTranslation';
import { useDirection } from '../../../../mybridgeui/src/custom-hooks/useDirection';
import {
  userStatus,
  userStatusMsg,
} from 'v4/components/header/status-dropdown/constant';
import classNames from 'classnames';
import TruncatedTextWithTooltip from 'v4/components/common/Tooltip';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
import { SearchSidebar } from 'v4/snippets/search/sidebar';

export const SiteShortcutLinks = ({ showCopyright, isDropDown, onSettingPageChange, ...props }) => {
  const [showAll, setShowAll] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [selectedLink, setSelectedLink] = useState(null);
  const {push,pathname}=useRouter()
  const { allDegreeConnectionsArr, pendingInvites } = useSelector((state) => state.connection);
  const { unreadMeetingCount } = useSelector((state) => state.globalData);
  const { dictionary } = useSelector((state) => state.translation);
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const { onClose, onOpen, isOpen } = useDisclosure();
  const [isSettingPage, setIsSettingPage] = useState(false);
  const currentLanguage = useSelector((state) => state.translation.language) || 'en';
  const isSettingsPath = pathname === "/profile/disk" || pathname.startsWith('/settings/') || pathname === "/notification" ||  pathname.startsWith('/profile/') || pathname.startsWith('/jobs/') 
  const { formatNumber } = useNumberFormatter();
  const { loggedIn } = useSelector((state) => state.user);
  
  // console.log("unreadMeetingCount = " + unreadMeetingCount);
  // useEffect(() => {
  //   if (allDegreeConnectionsArr?.length === 0) {
  //     dispatch(getAllConnectionsData());
  //   }
  // }, []);

  const connections = allDegreeConnectionsArr?.[0] ?? [];
  // const side = typeof window !== 'undefined' ? document.documentElement.dir : 'ltr';
  const direction = useDirection();

  const { userProfileInfo } = useSelector((state) => state.userProfile);
const userSlug = userProfileInfo?.slug || 'anonymous';


  useEffect(() => {
    if (connections?.length) {
      if (connections?.length >= 3) {
        setShowMore(true);
        return;
      }
      setShowAll(true);
    }
  }, [connections]);

  // useEffect(() => {
  //   if (loggedIn) {
  //     dispatch(getPendingInvitations({ type: 'pending' }));
  //   }
  // }, [loggedIn, dispatch]);

  const links = useMemo(
    () => [
      {
        title: t('navigation.home') || "Home",
        icon: <HomeIcon width={'24'} height={'24'} />,
        link: '/',
      },
      {
        title: t('navigation.myProfile') || "myProfile",
        icon: <ProfileIcon width={isDropDown ? '18' : '24'} height={isDropDown ? '18' : '24'} />,
        link: '/profile/me',
      },
      {
        title: t('navigation.myNetwork') || "myNetwork",
        icon: <MyNetworkNewIcon width={isDropDown ? '18' : '24'} height={isDropDown ? '18' : '24'} />,
        link: '/profile/network/my-circle',
      },
      {
        title: t('navigation.myCalendar') || "myCalendar",
        icon: <CalendarNewIcon width={isDropDown ? '18' : '24'} height={isDropDown ? '18' : '24'} />,
        link: '/profile/calendar',
      },
      {
        title: t('navigation.myMessages') || "myMessages",
        icon: <MessageColoredIcon width={isDropDown ? '18' : '24'} height={isDropDown ? '18' : '24'} />,
        link: '/profile/message',
      },
      {
        title: t('navigation.myNotifications') || "myNotifications",
        icon: <NotificationIconColored width={isDropDown ? '18' : '24'} height={isDropDown ? '18' : '24'} color="#4170A4" />,
        link: '/notification',
      },
      {
        title: t('navigation.myDisk') || "myDisk",
        icon: <DiskNewIcon width={isDropDown ? '18' : '24'} height={isDropDown ? '18' : '24'} />,
        link: '/profile/disk',
      },
      {
        title: t('navigation.myPages') || "myPages",
        icon: <PageIconColored width={isDropDown ? '18' : '24'} height={isDropDown ? '18' : '24'} />,
        link: '/settings/pages',
      },
      {
        title: t('navigation.jobs'),
        icon: <JobsIconColored width={isDropDown ? '18' : '24'} height={isDropDown ? '18' : '24'} />,
        link: '/jobs',
      },
      {
        title: t('navigation.teams'),
        icon: <TeamsIconColored width={isDropDown ? '18' : '24'} height={isDropDown ? '18' : '24'} />,
        link: '/teams',
      },
      {
        title: t('navigation.events'),
        icon: <MyEventsIconColored width={isDropDown ? '18' : '24'} height={isDropDown ? '18' : '24'} />,
        link: '/myevents',
      },
      {
        title: t('navigation.articles'),
        icon: <ArticleIconColored width={isDropDown ? '16' : '24'} height={isDropDown ? '16' : '24'} />,
        link: '/articles',
      },
    ],
    [t, isDropDown]
  );

  if(!loggedIn){
    return <SearchSidebar />
  }

  return (

    <Stack {...props}>
      <Stack  pb={showCopyright ? 4 : 0} >
        <Stack  p={isDropDown ? 0 : 3} spacing={0}>
          {links
            ?.filter?.((_, ind) => isDropDown || ind < 8)
            ?.map?.((li, liIndex) => (
              <HStack
                as={Link}
                href={li.link}
                className={styles.hideTitle}
                // bg='#e9e9e9'
                _hover={{
                  bg:"#b5b4b46e",
                  boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                }}
                cursor="pointer"
                p={1}
                borderRadius={'50px'}
                key={liIndex}
                // width={'200px'}
                pr={'0px'}
                m={1}
                onClick={() => {setSelectedLink(li.title)
                  if (li.link === '/profile/me') {
                    trackEvent(ANALYTICS_EVENTS.PersonalProfile, userSlug);
                  }
                  else if (li.link === '/profile/network/my-circle') {
                    trackEvent(ANALYTICS_EVENTS.Network, userSlug);
                  }
                    else if (li.link ==='/profile/calendar') {
                    trackEvent(ANALYTICS_EVENTS.Calendar, userSlug);
                  }
                    else if (li.link ==='/profile/message') {
                    trackEvent(ANALYTICS_EVENTS.Chat, userSlug);
                  } 
                  else if (li.link ==='/profile/disk') {
                    trackEvent(ANALYTICS_EVENTS.MyDisk, userSlug);
                  } 
                  else if (li.link ==='/notification') {
                    trackEvent(ANALYTICS_EVENTS.Notifications, userSlug);
                  }  
                }}
                >
                <Box
                  bg={pathname === li.link ? '#D9D9D9' : ''}
                  w={isDropDown ? '30px' : '40px'}
                  h={'40px'}
                  borderRadius="50%"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  pos="relative"
                >
                  {li.icon}
                  {li.title == t('navigation.myCalendar') && unreadMeetingCount > 0 && (
                    <Badge
                      position="absolute"
                      top="-4px"
                      right="-4px"
                      fontSize="10px"
                      bg="brandRed.500"
                      color="white"
                      borderRadius="100%"
                      w="20px"
                      h="20px"
                      border="2px solid #ffffff"
                      p={0}
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      zIndex={1}
                      sx={{
                        // '@media (min-width: 1330px)': {
                        '@media (min-width: 1024px)': {
                          display: 'none',
                        },
                      }}
                    >
                      {formatNumber(unreadMeetingCount)}
                    </Badge>
                  )}
                  {li.title == t('navigation.myNetwork') && pendingInvites?.length > 0 && (
                    <Badge
                      position="absolute"
                      top="-4px"
                      right="-4px"
                      fontSize="10px"
                      bg="brandRed.500"
                      color="white"
                      borderRadius="100%"
                      w="20px"
                      h="20px"
                      border="2px solid #ffffff"
                      p={0}
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      zIndex={1}
                      sx={{
                        // '@media (min-width: 1330px)': {
                        '@media (min-width: 1024px)': {
                          display: 'none',
                        },
                      }}
                    >
                      {formatNumber(pendingInvites?.length)}
                    </Badge>
                  )}
                </Box>
                {currentLanguage ===  'en' ? 
                <Text  className={styles.hideTitle} fontSize={'17px'} color={ pathname === li.link ?"black":"#575757"} fontWeight={"600"} flex={1}>
                  {li.title}
                </Text>
                :
                <Text  className={styles.hideTitle} fontSize={'17px'} color={ pathname === li.link ?"black":"#575757"} fontWeight={"600"} flex={1}>
                  {/* {li.title} */}
                  <TruncatedTextWithTooltip 
                    text={li.title}
                    maxChars={unreadMeetingCount > 0 ? 10 : 12}
                  />
                </Text>}
                {li.title == t('navigation.myCalendar') && unreadMeetingCount > 0 && (
                  <Badge
                    fontSize="12px"
                    bg="brandRed.500"
                    color="white"
                    borderRadius="100%"
                    w="25px"
                    h="25px"
                    border= '2px solid #ffffff'
                    p="3px 5px"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    pt="4px"
                    mr={2}
                    sx={{
                      // '@media (max-width: 1330px)': {
                      '@media (max-width: 1024px)': {
                        display: 'none',
                      },
                    }}
                  >
                    {formatNumber(unreadMeetingCount)}
                  </Badge>
                )}
                {li.title == t('navigation.myNetwork') && pendingInvites?.length > 0 && (
                  <Badge
                    fontSize="12px"
                    bg="brandRed.500"
                    color="white"
                    borderRadius="100%"
                    w="25px"
                    h="25px"
                    border= '2px solid #ffffff'
                    p="3px 5px"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    pt="4px"
                    mr={2}
                    sx={{
                      // '@media (max-width: 1330px)': {
                      '@media (max-width: 1024px)': {
                        display: 'none',
                      },
                    }}
                  >
                    {formatNumber(pendingInvites?.length)}
                  </Badge>
                )}
                {/* <ChevronRight height="12" /> */}
              </HStack>
            ))}

          <Box {...(direction === 'rtl' ? { pl: '40px' } : { pr: '40px' })}>
            <Popover isOpen={isOpen} onClose={() => {
              // Set isSettingPage to false when the popover closes
              setIsSettingPage(false);
              
              // Call the callback to inform parent component if it exists
              if (onSettingPageChange) {
                onSettingPageChange(false);
              }
              
              // Call the original onClose function
              onClose();
            }} placement="top-start" isLazy>
              <PopoverTrigger>
                <Box onClick={() => {
                  const newValue = !isSettingPage;
                  setIsSettingPage(newValue);
                  // Call the callback to inform parent component
                  if (onSettingPageChange) {
                    onSettingPageChange(newValue);
                  }
                  onOpen();
                }} _hover={{ bg: 'gray.100' }} className={styles.moreOption}>
                  <Box
                    display={['block', 'block', 'block']}
                    // width={['18px', '18px', 'auto']}
                  
                    mt="3px"
                    className={direction === 'rtl' ? styles.moreIconstyleRTL : styles.moreIconstyle}
                  >
                    <MoreIcon
                      width={ '28'}
                      height={'28'}
                    />
                  </Box>
                  <Box className={styles.more} flex="1" fontWeight={"600"} >
                    {/* {dictionary?.navigation?.more || 'More'} */}
                    {t('navigation.more') || "More"}
                  </Box>
                  <Box display={['block', 'block', 'block']}>
                  </Box>
                </Box>
              </PopoverTrigger>
              {isSettingsPath ? 
                (currentLanguage ===  'en' ? <Portal>
                  <PopoverContent marginBottom="-50px" className={styles.moreDropdown} sx={{ zIndex: 99999 }}>
                    <PopoverBody style={{ outline: 'none', borderRadius: '8px' }}>
                      <List>
                        {[
                          { title: t('navigation.myJobs') || 'myJobs', icon: <JobsIconColored width="24" height="24" />, link: '/jobs' },
                          { title: t('navigation.myTeams') || 'myTeams', icon: <TeamsIconColored width="24" height="24" />, link: '/teams' },
                          { title: t('navigation.myEvents') || 'myEvents', icon: <MyEventsIconColored width="24" height="24" />, link: '/myevents' },
                          { title: t('navigation.myArticles') || 'myArticles', icon: <ArticleIconColored width="24" height="24" />, link: '/articles' },
                          { title: t('navigation.mySettings') || 'mySettings', icon: <SettingsIconColored width="24" height="24" />, link: '/settings/account' },
                          { title: t('navigation.termsAndPolicy') || 'Terms & Policy', icon: <TermsIconColored width="24" height="24" />, link: '/terms-of-use' },
                          { title: t('navigation.support') || 'Support', icon: <HelpSupportIconColored width="24" height="24" />, link: '/support' },
                          { title: t('navigation.business') || 'Business', icon: <BusinessIconColored width="24" height="24" />, link: '/business' }
                        ].map((item, index) => (
                          <ListItem
                      zIndex={999999999999999}
                            key={index}
                            cursor="pointer"
                            className={styles.dropItem}
                            // key={i}
                            as={HStack}
                            alignItems="flex-start"
                            _hover={{ bg: 'gray.100' }}
                            borderRadius="5"
                            
                            onClick={() => {
                              // Call onClose to close the popover when item is clicked
                              onClose();
                              // Redirect or perform other actions
                              push(item.link);
                            }}
                          >
                            <HStack flex={1} alignItems="center">
                              <Box as="span" className={styles.shortcutsIcon}>
                                {item.icon}
                              </Box>
                              <Box>
                                {/* <Text>{item.title}</Text> */}
                                {currentLanguage ===  'en' ?
                              <Text>{item.title}</Text>
                              :
                              <TruncatedTextWithTooltip
                              placement='top'
                              text={item.title}
                              maxChars={12}
                            />}
                              </Box>
                            </HStack>
                            {/* <Box>{selected.id === status.id ? <CheckIcon /> : ''}</Box> */}
                          </ListItem>
                        ))}
                      </List>
                    </PopoverBody>
                  </PopoverContent>
                </Portal> : 
                (<Portal>
                  <PopoverContent marginBottom="-50px" className={styles.moreDropdown} sx={{ zIndex: 99999 }}>
                  <PopoverBody style={{ outline: 'none', borderRadius: '8px' }}>
                    <List>
                      {[
                        { title: t('navigation.myJobs') || 'myJobs', icon: <JobsIconColored width="24" height="24" />, link: '/jobs' },
                        { title: t('navigation.myTeams') || 'myTeams', icon: <TeamsIconColored width="24" height="24" />, link: '/teams' },
                        { title: t('navigation.myEvents') || 'myEvents', icon: <MyEventsIconColored width="24" height="24" />, link: '/myevents' },
                        { title: t('navigation.myArticles') || 'myArticles', icon: <ArticleIconColored width="24" height="24" />, link: '/articles' },
                        { title: t('navigation.mySettings') || 'mySettings', icon: <SettingsIconColored width="24" height="24" />, link: '/settings/account' },
                        { title: t('navigation.termsAndPolicy') || 'Terms & Policy', icon: <TermsIconColored width="24" height="24" />, link: '/terms-of-use' },
                        { title: t('navigation.support') || 'Support', icon: <HelpSupportIconColored width="24" height="24" />, link: '/support' },
                        { title: t('navigation.business') || 'Business', icon: <BusinessIconColored width="24" height="24" />, link: '/business' }
                      ].map((item, index) => (
                        <ListItem
                    zIndex={999999999999999}
                          key={index}
                          cursor="pointer"
                          className={styles.dropItem}
                          // key={i}
                          as={HStack}
                          alignItems="flex-start"
                          _hover={{ bg: 'gray.100' }}
                          borderRadius="5"
                          
                          onClick={() => {
                            // Call onClose to close the popover when item is clicked
                            onClose();
                            // Redirect or perform other actions
                            push(item.link);
                          }}
                        >
                          <HStack flex={1} alignItems="center">
                            <Box as="span" className={styles.shortcutsIcon}>
                              {item.icon}
                            </Box>
                            <Box>
                              {/* <Text>{item.title}</Text> */}
                              {currentLanguage ===  'en' ?
                            <Text>{item.title}</Text>
                            :
                            <TruncatedTextWithTooltip
                            placement='top'
                            text={item.title}
                            maxChars={12}
                          />}
                            </Box>
                          </HStack>
                          {/* <Box>{selected.id === status.id ? <CheckIcon /> : ''}</Box> */}
                        </ListItem>
                      ))}
                    </List>
                  </PopoverBody>
                </PopoverContent>
                </Portal>)
                )
                :
                <Portal>
                  <PopoverContent marginBottom="-50px" className={styles.moreDropdown} sx={{ zIndex: 999999999 }}>
                  <PopoverBody style={{ outline: 'none', borderRadius: '8px' }}>
                    <List>
                      {[
                        { title: t('navigation.myJobs') || 'myJobs', icon: <JobsIconColored width="24" height="24" />, link: '/jobs' },
                        { title: t('navigation.myTeams') || 'myTeams', icon: <TeamsIconColored width="24" height="24" />, link: '/teams' },
                        { title: t('navigation.myEvents') || 'myEvents', icon: <MyEventsIconColored width="24" height="24" />, link: '/myevents' },
                        { title: t('navigation.myArticles') || 'myArticles', icon: <ArticleIconColored width="24" height="24" />, link: '/articles' },
                        { title: t('navigation.mySettings') || 'mySettings', icon: <SettingsIconColored width="24" height="24" />, link: '/settings/account' },
                        { title: t('navigation.termsAndPolicy') || 'Terms & Policy', icon: <TermsIconColored width="24" height="24" />, link: '/terms-of-use' },
                        { title: t('navigation.support') || 'Support', icon: <HelpSupportIconColored width="24" height="24" />, link: '/support' },
                        { title: t('navigation.business') || 'Business', icon: <BusinessIconColored width="24" height="24" />, link: '/business' }
                      ].map((item, index) => (
                        <ListItem
                    zIndex={999999999999999}
                          key={index}
                          cursor="pointer"
                          className={styles.dropItem}
                          // key={i}
                          as={HStack}
                          alignItems="flex-start"
                          _hover={{ bg: 'gray.100' }}
                          borderRadius="5"
                          
                          onClick={() => {
                            // Call onClose to close the popover when item is clicked
                            onClose();
                            // Redirect or perform other actions
                            push(item.link);
                          }}
                        >
                          <HStack flex={1} alignItems="center">
                            <Box as="span" className={styles.shortcutsIcon}>
                              {item.icon}
                            </Box>
                            <Box>
                              {currentLanguage ===  'en' ?
                              <Text>{item.title}</Text>
                              :
                                <Text>
                                {/* {item.title} */}
                                <TruncatedTextWithTooltip 
                                  text={item.title}
                                  maxChars={12}
                                />
                              </Text>}
                            </Box>
                          </HStack>
                          {/* <Box>{selected.id === status.id ? <CheckIcon /> : ''}</Box> */}
                        </ListItem>
                      ))}
                    </List>
                  </PopoverBody>
                </PopoverContent>
                </Portal>
              }
            </Popover>
          </Box>
        </Stack>
      </Stack>
    </Stack>

  );
};
